import { render } from "./systemCustomMenu.vue?vue&type=template&id=635e8366&scoped=true"
import script from "./systemCustomMenu.vue?vue&type=script&lang=js"
export * from "./systemCustomMenu.vue?vue&type=script&lang=js"

import "./systemCustomMenu.vue?vue&type=style&index=0&id=635e8366&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635e8366"]])

export default __exports__